import Axios from "axios";
import {
    SET_INV_SAMPLE_DELIVERY_LIST,
    UNSET_INV_SAMPLE_DELIVERY_LIST,
    SET_EDITING_INV_SAMPLE_DELIVERY,
    UNSET_EDITING_INV_SAMPLE_DELIVERY,
    SET_INV_APPROVED_SAMPLE_DELIVERY_LIST,
    UNSET_INV_APPROVED_SAMPLE_DELIVERY_LIST
} from "@/store/mutation-types";
import {
    getInvSampleDeliveryList,
    getInvSampleDeliveryById as getInvSampleDeliveryByIdApi,
    saveUpdateInvSampleDelivery,
    getInvApprovedSampleDeliveryList,
} from "@/store/api";

const state = {
    getInvSampleDeliveryList: [],
    editingInvSampleDelivery: null,
    getInvApprovedSampleDeliveryList:[],
};

const getters = {
    getInvSampleDeliveryList(state) {
        return state.getInvSampleDeliveryList;
    },
    getEditingInvSampleDelivery (state) {
        return state.editingInvSampleDelivery;
    },
    getInvApprovedSampleDeliveryList(state) {
        return state.getInvApprovedSampleDeliveryList;
    }
};

const mutations = {
    [SET_INV_SAMPLE_DELIVERY_LIST](state, data) {
        state.getInvSampleDeliveryList = data;
    },
    [UNSET_INV_SAMPLE_DELIVERY_LIST](state) {
        state.getInvSampleDeliveryList = [];
    },
    [SET_EDITING_INV_SAMPLE_DELIVERY](state, data) {
        state.editingInvSampleDelivery = data;
    },
    [UNSET_EDITING_INV_SAMPLE_DELIVERY](state) {
        state.editingInvSampleDelivery = null;
    },
    [SET_INV_APPROVED_SAMPLE_DELIVERY_LIST](state, data) {
        state.getInvApprovedSampleDeliveryList = data;
    },
    [UNSET_INV_APPROVED_SAMPLE_DELIVERY_LIST](state) {
        state.getInvApprovedSampleDeliveryList = null;
    },
};

const actions = {
    getInvApprovedSampleDeliveryList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`${getInvApprovedSampleDeliveryList}`, { params: data })
                .then(function (response) {
                    commit('SET_INV_APPROVED_SAMPLE_DELIVERY_LIST', response.data.data);
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_INV_APPROVED_SAMPLE_DELIVERY_LIST');
                    reject(error);
                })
                .then(() => {

                })
        })
    },
    saveUpdateInvSampleDelivery({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateInvSampleDelivery, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getInvSampleDeliveryList({ commit }, data) {
        return new Promise((resolve, reject) => {
                Axios.get(getInvSampleDeliveryList, { params: data })
                    .then(function (response) {
                        commit("SET_INV_SAMPLE_DELIVERY_LIST", response.data.data);
                        resolve(response);
                    })
                    .catch(function (error) {
                        commit("UNSET_INV_SAMPLE_DELIVERY_LIST");
                        reject(error);
                    })
                    .then((always) => {});
            }
        );
    },

    getInvSampleDeliveryById({ commit }, id) {
        const getInvSampleDeliveryById = `${getInvSampleDeliveryByIdApi}/${id}`;
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
                Axios.get(getInvSampleDeliveryById)
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((error) => {
                        reject(error);
                    })
                    .then((always) => {
                        commit("UNSET_LOADING");
                    });
            }
        );
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
